import { hasCreatorAccess } from "./roleUtils";

/**
 * Avatar click destination — see _reference/cursor-handoff.md routing.
 * Creators/superadmins → public profile at /creator/:handle.
 * Fans → /fan/:userId. Dashboard is sidebar-only, never from the avatar.
 */
export function getProfileNavPath(currentUser, userProfile) {
  if (!currentUser || !userProfile) return "/welcome?auth=signin";

  if (hasCreatorAccess(userProfile)) {
    const handle = userProfile.handle || userProfile.username;
    return handle ? `/creator/${handle}` : `/fan/${currentUser.uid}`;
  }

  return `/fan/${currentUser.uid}`;
}
